module.exports = __webpack_public_path__ + "img/login_bj.fdc0ffcf.jpg";